<template>
  <article class="message is-success">
    <div class="message-header">
      <p>
        {{ $texts('downloadVoucher', 'Persönlicher Gutschein herunterladen') }}
      </p>
    </div>
    <div class="message-body">
      <p
        class="mb-4"
        v-html="
          $texts(
            'takeAdvantage',
            'Um dieses Angebot nutzen zu können, laden Sie bitte den Gutschein auf Ihren Computer herunter und drucken Sie ihn aus, indem Sie auf den unten stehenden Link klicken. Alles Weitere ist auf dem Gutschein vermerkt. Er ist nicht übertragbar und nur mit einem Passfoto gültig, das Sie in Ihrem Profil hochladen können. Jeder Gutschein hat eine eindeutige Kennung und kann nur einmal verwendet werden. Pro Mitglied kann nur ein Gutschein eingelöst werden.',
          )
        "
      />
      <button
        class="button is-normal is-fullwidth mb-2"
        @click="generateVoucher"
      >
        {{
          $texts('generateVoucher', 'Gutschein generieren und herunterladen')
        }}
      </button>
    </div>
    <loading v-model:is-active="isLoading" />
  </article>
</template>

<script setup lang="ts">
const props = defineProps<{
  benefit?: number
}>()

const { $texts } = useNuxtApp()
const isLoading = ref(false)
const language = useCurrentLanguage()

const generateVoucher = async () => {
  isLoading.value = true

  const variables = {
    benefit: '' + props.benefit,
  }

  const id = await useGraphqlMutation('createVoucher', variables).then((v) => {
    return v.data.createVoucher.id || null
  })

  if (id) {
    let prefix = '/' + language.value
    if (language.value === 'de') {
      prefix = ''
    }
    window.location.href = prefix + '/pdf/voucher/' + id
  }
  isLoading.value = false
}
</script>
